import PCUPage from 'features/pcu/page';

export default PCUPage;
